import React from 'react'
import ErrorBoundary from 'components/Errors/ErrorBoundary/ErrorBoundary'

export default (options = {}) => {
  return (WrappedComponent) => {
    return (props) => {
      return (
        <ErrorBoundary {...options || {}}>
          <WrappedComponent {...{...props}}/>
        </ErrorBoundary>
      )

    }
  }
}
